module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/blogs/bravenet_blogs_stock_photos_library.png";